<template>
  <div class="aframe-360-viewer text-center">
    <v-snackbar v-model="snackbar" vertical :timeout="20000" top>
      <h2>{{ getTranslation('Bem Vindo à Prática 360:', 'Bienvenido a la práctica 360:') }} <span class="primary--text">{{ getFirstPracticeIntroTitle() }}</span></h2> <br>
      {{ getTranslation(
        `Inicie sua experiência explorando essa imagem 360 graus e quando estiver pronto para iniciar clique no botão "Vamos Lá!"`,
       'Comience su experiencia explorando esta imagen de 360 grados y cuando esté listo para comenzar, haga clic en el botón "¡Vamos allá!"') 
       }} 
      <br><br>
      {{ getTranslation(
        'Clique no botão à esquerda para acessar o menu e navegar entre as etapas da experiência.',
       'Haga clic en el botón a la izquierda para acceder al menú y navegar entre las etapas de la experiencia.')
       }}
      
      <v-btn dark text @click="snackbar = false">
        {{ getTranslation(
        'Fechar',
        'Cerrar')
       }}
        
      </v-btn>
    </v-snackbar>
    <v-img v-if="disappear" src="../../../public/img/swipe_animation.gif" class="swipe-animation"
      transition="scale-transition" />
    <v-btn large class="floating-button" @click="$emit('selectComponent', 'CoreEtapa2'), $emit('nextStep', '2')">
      {{ getTranslation(
        'Vamos Lá!',
        '¡Vamos allá!')
       }}
    </v-btn>
  </div>
</template>

<script>
import Const from '@/helpers/const'
let json = require('../../json/pratica-' + Const.PRACTICE_NUMBER + '.json')
export default {
  data() {
    return {
      json: json,
      snackbar: true,
      id: null,
      disappear: true
    }
  },
  mounted() {
    let vm = this
    // we need this to account for Android navbottom bar
    const buttonPosition = () => {
      const doc = document.documentElement
      const position = document.body.scrollHeight - window.innerHeight
      doc.style.setProperty('--button-position', `${position}px`)
    }
    window.addEventListener('resize', buttonPosition)
    buttonPosition()
    setTimeout(function () {
      vm.disappear = false
    }, 6000)
  },

  methods: {
    getFirstPracticeIntroTitle() {
      const pratica = this.json.pratica[0]
      return pratica.introducao.titulo
    },
    getTranslation(elementPortuguese, elementSpanish){
      
      if(Const.PRACTICE_NUMBER.includes('es')){
        return elementSpanish
      }

      return elementPortuguese
    },
  }
}
</script>

<style scoped>
.aframe-360-viewer {
  background-color: #ffffff;
  overflow: hidden;
  height: 100vh;
}

.swipe-animation {
  position: absolute;
  width: 120px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  bottom: 250px;
}

.floating-button {
  position: absolute;
  bottom: 100px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

@media only screen and (max-width: 800px) {
  .floating-button {
    bottom: var(--button-position);
    width: 100%;
  }
}

.headline {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 20px !important;
}

.vswipe {
  display: none;
}
</style>
